import ApiRequestManagerInstance from '../ApiRequestManager';
import Category from '../../classes/category';
import TranslationManager from '../../assets/locale/translationsManager';
import { ICategory, ICategoriesRequest } from '../../types/interfaces/category';

function categoriesRequest() {
  const promise = new Promise<Category[]>(async (resolve, reject) => {
    try {
      const response: ICategoriesRequest = (await ApiRequestManagerInstance.get(
        {
          endpoint: {
            url: 'cdnSyncUrl',
            section: 'media',
            subsection: `categories.${TranslationManager.currentLanguage}.json`,
          },
        }
      )) as unknown as ICategoriesRequest;
      const categories = response.data.map(
        (category: ICategory) => new Category(category)
      );
      resolve(categories);
    } catch (e) {
      console.error(e);
      reject([]);
    }
  });

  return promise;
}

export default categoriesRequest;
